/**
 * Generates a File object from a url
 * @param url
 * @param mimeType
 */
export const getFileFromUrl = async (url: string, mimeType = 'image/png') => {
  const response = await fetch(url);
  const blob = await response.blob();
  return new File([blob], url, { type: mimeType });
};
